export const DEALERS_OVERVIEW_GET_DATA_REQUEST = "DEALERS_OVERVIEW_GET_DATA_REQUEST";
export const DEALERS_OVERVIEW_GET_DATA_RESULT = "DEALERS_OVERVIEW_GET_DATA_RESULT";